import { render } from "./DynamicBanner.vue?vue&type=template&id=4a9a11f2&scoped=true"
import script from "./DynamicBanner.vue?vue&type=script&lang=js"
export * from "./DynamicBanner.vue?vue&type=script&lang=js"

import "./DynamicBanner.vue?vue&type=style&index=0&id=4a9a11f2&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9a11f2"]])

export default __exports__